class Contact {
  constructor() {
    $(document).ready(() => {
      this.initialize();
    })
  }

  initialize() {
    this.isOpen = false;
    this.isMobile = window.innerWidth <= 768;
    this.contactButton = document.querySelector('[data-contact-button]');
    if(!this.contactButton) return;
    
    this.closeCursor = document.querySelector('[data-close-cursor]');
    if(this.closeCursor) this.cursorPos = this.closeCursor.getBoundingClientRect();
    this.x = 0;
    this.y = 0;
    this.pos = { x: 0, y: 0 }
    this.contactForm = document.querySelector('[data-contact-form]');
    this.formInner = document.querySelector('.contact-form__inner');
    this.contactClose = document.querySelector('[data-contact-close]');
    this.hovers = document.querySelectorAll('[data-contact-hover-container]');

    if(window.location.search.includes('studio')) {
      const option = document.querySelector('option[value="Adjust Studio Time"]');
      option.selected = true;
      this.contactForm.classList.add('active');
      this.isOpen = true;
    }

    $('select').customA11ySelect();
    
    this.addEventListeners();
    this.animate = this.animate.bind(this);
    this.animate();
  }

  addEventListeners() {
    this.contactButton.addEventListener('click', () => {
      this.contactForm.classList.add('active');
      this.isOpen = true;
    });
    
    this.contactClose.addEventListener('click', () => {
      this.contactForm.classList.remove('active')
      this.isOpen = false;
    });

    this.formInner.addEventListener('mouseenter', () => {
      this.closeCursor.classList.add('inactive')
    })

    this.formInner.addEventListener('mouseleave', () => {
      this.closeCursor.classList.remove('inactive')
    })

    window.addEventListener('mousemove', (e) => {
      if(this.cursorPos) {
        this.pos = {
          x: e.pageX,
          y: e.pageY
        }
      }
    });

    this.hovers.forEach(el => {
      el.addEventListener('mouseenter', this.handleMouseEnter.bind(this, el));
      el.addEventListener('mouseleave', this.handleMouseLeave.bind(this, el));
      el.addEventListener('mousemove', this.handleMouseMove.bind(this, el));
    })
  }

  handleMouseEnter(el, e) {
    const hover = el.querySelector('[data-contact-hover]');
    if(hover) {
      hover.classList.add('active');
    }
  }

  handleMouseLeave(el, e) {
    const hover = el.querySelector('[data-contact-hover]');
    if(hover) {
      hover.classList.remove('active')
    }
  }

  handleMouseMove(el, e) {
    const { pageX, pageY } = e;
    const link = e.target.querySelector('a') || e.target;
    const linkType = link.href.includes('tel') ? 'call' : link.href.includes('mailto') ? 'email' : null;
    const pos = el.getBoundingClientRect();
    const hover = el.querySelector('[data-contact-hover]');
    
    if(linkType) {
      el.querySelector('[data-contact-hover-text]').innerText = linkType
    }

    if(hover) {
      hover.style.left = `${pageX - pos.x}px`;
      hover.style.top = `${ pageY - pos.y}px`;
    }

  }

  animate() {
    if(this.cursorPos && this.isOpen && !this.isMobile) {
      this.x = lerp(this.x, this.pos.x - this.cursorPos.width / 2, 0.1);
      this.y = lerp(this.y, this.pos.y - this.cursorPos.height / 2, 0.1);
  
      this.closeCursor.style.transform = `translate3d(${this.x}px, ${this.y}px, 0)`;
    }
    requestAnimationFrame(this.animate);
  }
}
const contactForm = new Contact();